import React from 'react';
import { makeStyles } from 'react-scale/components/design-system/styles';
import {
  isChapterWorkflowStep,
  isCheckEveryWorkflowStep,
  TraversedTaskerWorkflowStep,
  isAnnotationWorkflowStep,
  isAnnotationSubstepWorkflowStep,
} from '@scale/shared/taskerWorkflow/TaskerWorkflow';
import ChapterToolTip from './WorkflowToolTips/ChapterToolTip';
import AnnotationToolTip from './WorkflowToolTips/AnnotationToolTip';
import CheckEveryParentToolTip from './WorkflowToolTips/CheckEveryParentToolTip';
import DefaultToolTip from './WorkflowToolTips/DefaultToolTip';
import AnnotationSubstepToolTip from './WorkflowToolTips/AnnotationSubstepToolTip';
import { WorkflowHook } from '../Sidebar/GuidedWorkflowPanel/useWorkflow';
import { LabelerStateHook } from 'react-scale/hooks/useLabelerState';
import { ReviewStateHook } from 'react-scale/components/scalers/tooling/reviews/useReviewState';

const useStyles = makeStyles({
  workflowToolTipContainer: {
    width: 260,
    maxHeight: 600,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    borderRadius: '4px',
    filter: 'drop-shadow(0 -4px 16px rgba(0, 0, 0, 0.5))',
  },
  tooltipArrow: {
    position: 'absolute',
    transform: 'translateX(-50%)',
    marginLeft: '130px',
    marginTop: '-10px',
    borderLeft: '15px solid transparent',
    borderRight: '15px solid transparent',
    borderBottom: '10px solid white',
  },
});

interface WorkflowStepToolTipProps {
  workflowHook: WorkflowHook;
  labelerStateHook?: LabelerStateHook;
  reviewStateHook?: ReviewStateHook;
}
const WorkflowStepToolTip: React.FC<WorkflowStepToolTipProps> = props => {
  const classes = useStyles();

  const { currentStep } = props.workflowHook.workflowState;

  if (!currentStep) return <div>No active step</div>;

  const getCurrentToolTip = (step: TraversedTaskerWorkflowStep) => {
    if (isChapterWorkflowStep(step)) {
      return <ChapterToolTip workflowHook={props.workflowHook} />;
    } else if (isCheckEveryWorkflowStep(step)) {
      return props.labelerStateHook ? (
        <CheckEveryParentToolTip
          workflowHook={props.workflowHook}
          labelerStateHook={props.labelerStateHook}
        />
      ) : (
        <DefaultToolTip workflowHook={props.workflowHook} />
      );
    } else if (isAnnotationWorkflowStep(step)) {
      if (isAnnotationSubstepWorkflowStep(step)) {
        return props.labelerStateHook ? (
          <AnnotationSubstepToolTip
            workflowHook={props.workflowHook}
            labelerStateHook={props.labelerStateHook}
          />
        ) : (
          <DefaultToolTip workflowHook={props.workflowHook} />
        );
      }
      return props.labelerStateHook ? (
        <AnnotationToolTip
          workflowHook={props.workflowHook}
          labelerStateHook={props.labelerStateHook}
          reviewStateHook={props.reviewStateHook}
        />
      ) : (
        <DefaultToolTip workflowHook={props.workflowHook} />
      );
    } else {
      return <DefaultToolTip workflowHook={props.workflowHook} />;
    }
  };

  return (
    <div>
      <div className={classes.tooltipArrow}> </div>
      <div className={classes.workflowToolTipContainer}>{getCurrentToolTip(currentStep)}</div>
    </div>
  );
};

export default React.memo(WorkflowStepToolTip);
